import {
  Card,
  CardBody,
  CardImg,
  CardSubtitle,
  CardTitle,
  Button,
} from "reactstrap";
import React from "react";

const Item = (props) => {
  const [img, setImg] = React.useState();

  React.useEffect(() => {
    setImg(props.image)
  }, [props]);

  return (
    <Card
        onMouseOver={() => setImg(props.imageover)}
        onMouseLeave={() => setImg(props.image)}
    >
      <div className="image">
        <CardImg alt="Card image cap" src={img} />
      </div>
      <CardBody className="p-4">
        <CardTitle tag="h5">{props.title}</CardTitle>
        <CardSubtitle className="text-end">{props.subtitle}</CardSubtitle>
        <Button color="primary" as="a" href={props.href}>Buy on Amazon</Button>
      </CardBody>
    </Card>
  );
};

export default Item;
